import { socialImages } from "@/mocks/homeData";

export default function SocialSection() {
  return (
    <section className="w-full py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {/* LINE */}
          <div className="relative rounded-xl overflow-hidden bg-secondary-50 border border-secondary-200">
            <div className="flex items-center p-5 md:p-6">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-3">
                  <i className="ri-chat-3-line text-secondary-600 text-xl"></i>
                  <h3 className="text-base md:text-lg font-bold text-foreground-950">
                    LINEで最新情報をお届け！
                  </h3>
                </div>
                <p className="text-xs md:text-sm text-foreground-600 mb-4 leading-relaxed">
                  新着記事やお得な情報を
                  <br />
                  いち早くGET♪
                </p>
                <button className="inline-flex items-center gap-2 bg-[#06C755] text-white px-5 py-2.5 rounded-full text-sm font-bold hover:opacity-90 transition-opacity">
                  <i className="ri-chat-3-line text-sm"></i>
                  LINEで友だち追加
                </button>
              </div>
              <div className="w-24 h-32 md:w-32 md:h-40 shrink-0 ml-4">
                <img
                  src={socialImages.line}
                  alt="LINE友だち追加"
                  className="w-full h-full object-cover rounded-lg"
                />
              </div>
            </div>
          </div>

          {/* Instagram */}
          <div className="relative rounded-xl overflow-hidden bg-primary-50 border border-primary-200">
            <div className="flex items-center p-5 md:p-6">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-3">
                  <i className="ri-instagram-line text-primary-600 text-xl"></i>
                  <h3 className="text-base md:text-lg font-bold text-foreground-950">
                    Instagramもチェック！
                  </h3>
                </div>
                <p className="text-xs md:text-sm text-foreground-600 mb-4 leading-relaxed">
                  ママに役立つ情報や
                  <br />
                  おすすめのアイテムを発信中♡
                </p>
                <button className="inline-flex items-center gap-2 bg-primary-500 text-white px-5 py-2.5 rounded-full text-sm font-bold hover:bg-primary-600 transition-colors">
                  <i className="ri-instagram-line text-sm"></i>
                  フォローする
                </button>
              </div>
              <div className="w-24 h-32 md:w-32 md:h-40 shrink-0 ml-4">
                <img
                  src={socialImages.instagram}
                  alt="Instagramフォロー"
                  className="w-full h-full object-cover rounded-lg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}